import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'
import Home from '../views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      hasNavigation: true,
      requiresAdmin: true,
      requiresAuth: true,
    }
  },
  {
    path: '/code/checkin',
    name: 'QRCode',
    component: () => import('../views/QRCode.vue')
  },
  {
    path: '/curriculum/:id',
    name: 'Curriculum',
    component: () => import('../views/Curriculum.vue'),
    meta: {
      hasNavigation: true,
      requiresAdmin: true,
      requiresAuth: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: {
      hasNavigation: true,
      requiresAdmin: true,
      requiresAuth: true
    }
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: () => import('../views/Calendar.vue'),
    meta: {
      hasNavigation: true,
      requiresAdmin: true,
      requiresAuth: true
    }
  },
  {
    path: '/dashboard/dei',
    name: 'DEI Report',
    component: () => import('../views/ReportDei.vue'),
    meta: {
      hasNavigation: true,
      requiresAdmin: true,
      requiresAuth: true
    }
  },
  {
    path: '/employee/:id',
    name: 'Employee',
    component: () => import('../views/Employee.vue'),
    meta: {
      hasNavigation: true,
      requiresAdmin: true,
      requiresAuth: true
    }
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue'),
    meta: {
      hasNavigation: false
    }
  },
  {
    path: '/directory',
    name: 'Employee Directory',
    component: () => import('../views/EmployeeDirectory.vue'),
    meta: {
      hasNavigation: true,
      requiresAdmin: true,
      requiresAuth: true
    }
  },
  {
    path: '/clearances',
    name: 'Tests',
    component: () => import('../views/Tests.vue'),
    meta: {
      hasNavigation: true,
      requiresAuth: true,
      requiresAdmin: true,
      requiresClearances: true,
    }
  },
  {
    path: '/scan',
    name: 'ScanCheckIn',
    component: () => import('../views/ScanCheckIn.vue'),
    meta: {
      hasNavigation: false
    }
  },
  {
    path: '/check-in',
    name: 'Check In',
    component: () => import('../views/CheckIn.vue'),
    meta: {
      hasNavigation: false,
      requiresAuth: true,
      redirectMessage: {
        type: 'warning',
        message: 'You must first login to check-in to a training'
      }
    }
  },
  {
    path: '/session/:id',
    name: 'Session',
    component: () => import('../views/Session.vue'),
    meta: {
      hasNavigation: true,
      requiresAdmin: true,
      requiresAuth: true
    }
  },
  {
    path: '/training/:slug',
    name: 'PublicTrainingSignUp',
    component: () => import('../views/PublicTrainingSignUp.vue'),
    meta: {
      hasNavigation: false,
      requiresAuth: true,
      redirectMessage: {
        type: 'warning',
        message: 'You must first login to sign up for training.'
      }
    }
  },
  {
    path: '/acknowledgement/:id',
    name: 'Acknowledgement',
    component: () => import('../views/Acknowledgement.vue'),
    meta: {
      hasNavigation: false,
      requiresAuth: true,
      redirectMessage: {
        type: 'warning',
        message: 'You must first login to acknowledge a training.'
      }
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: {
      hasNavigation: false,
      requiresAuth: true,
      redirectMessage: {
        type: 'warning',
        message: 'You must first login to access your profile.'
      }
    }
  },
  {
    path: '/role-eligibility-application',
    name: 'RoleEligibilityApplication',
    component: () => import('../views/RoleEligibilityApplication.vue'),
    meta: {
      hasNavigation: false,
      requiresAuth: true,
      redirectMessage: {
        type: 'warning',
        message: 'You must first login to access the role eligibility application.'
      }
    }
  },
  {
    path: '/upload/employees',
    name: 'Upload Employees',
    component: () => import('../views/UploadEmployees.vue'),
    meta: {
      hasNavigation: true,
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/welcome',
    name: 'Welcome',
    component: () => import('../views/Welcome.vue'),
    meta: {
      hasNavigation: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      hasNavigation: false
    }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('../views/Signup.vue'),
    meta: {
      hasNavigation: false
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout.vue'),
    meta: {
      hasNavigation: false
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  /*
  ** Handle auth requests where no firebase user is present
  */
  const currentUser = firebase.auth().currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const redirectMessage = to.meta.redirectMessage
  const hasNavigation = to.meta.hasNavigation
  
  store.dispatch('setShowNav', hasNavigation)
  store.dispatch('setLoadingApp', false)
  
  if (!requiresAuth && !requiresAdmin) {
    return next()
  }
  
  if (requiresAuth && !currentUser) {
  if (redirectMessage) { routerHelpers.showRedirectMessage(redirectMessage) }
    return next('login?from=' + to.path)
  }
  
  if (requiresAdmin && !currentUser) {
    if (redirectMessage) { routerHelpers.showRedirectMessage(redirectMessage) }
    return next('login?from=' + to.path)
  }
  
  /*
  ** Handle auth requests where custom meta is needed
  */
  
  let airtableUserRecord = store.getters.getUser
  if (!airtableUserRecord) {
    airtableUserRecord = await routerHelpers.getAirtableUserRecord(currentUser)
  }
  const userCustomMeta = airtableUserRecord.customMeta
  const userIsAdmin = userCustomMeta && userCustomMeta.fields.Role === 'Admin'

  if (requiresAdmin && !userIsAdmin) {
    store.dispatch('setSnackbar', {
      snackbarColor: 'error',
      showSnackbar: true,
      snackbarY: 'top',
      snackbarX: 'right',
      snackbarText: `You do not have permission to access that page.`
    })
    return next('/error')
  }

  const requiresClearances = to.matched.some(record => record.meta.requiresClearances)
  const userHasClearances = userCustomMeta && userCustomMeta.fields.Clearances
  if (requiresClearances && !userHasClearances) {
    store.dispatch('setSnackbar', {
      snackbarColor: 'error',
      showSnackbar: true,
      snackbarY: 'top',
      snackbarX: 'right',
      snackbarText: `You do not have permission to access that page.`
    })
    return next('/error')
  }
  next()
})

const routerHelpers = {
  showRedirectMessage (redirectMessage) {
    store.dispatch('setSnackbar', {
      snackbarColor: redirectMessage.type,
      showSnackbar: true,
      snackbarY: 'top',
      snackbarX: 'center',
      snackbarText: redirectMessage.message
    })
  },
  getAirtableUserRecord (currentUser) {
    return new Promise((resolve, reject) => {
      store.dispatch('setLoadingApp', true)
      store.dispatch('getRecords', {
        table: 'Users',
        view: 'All Users'
      })
      .then(userRecords => {
        store.dispatch('setLoadingApp', false)
        currentUser.customMeta = userRecords.find(record => {
          return currentUser.uid === record.fields['Firebase ID']
        })
        return resolve(currentUser)
      })
      .catch(err => {
        store.dispatch('setLoadingApp', false)
        store.dispatch('setSnackbar', {
          snackbarColor: 'error',
          showSnackbar: true,
          snackbarY: 'top',
          snackbarX: 'right',
          snackbarText: `There are issues authorizing you on this page.`
        })
        console.log(err)
        return reject(err)
      })
    })
  }
}

export default router
